import { useMemo } from 'react';
import { Formik } from 'formik';
import { Badge, Col, Container, Row } from 'react-bootstrap';
import { DevicePolicyEnum } from './devicePolicy/DevicePolicy';
import MenuTabs from './MenuTabs';
import ControlPanel from './ControlPanel';
import { SettingsContext } from './useSettings';
import useRequireAuth from '../../hooks/useRequireAuth';
import { useTeamsGwPrompts } from '../hooks/useTeamsGwPrompts';
import ProgressModal from '../util/ProgressModal';
import LoadingMessage from './utils/LoadingMessage';
import { useSettingsHandlers } from './useSettingsHandlers';

function Settings() {
  const auth = useRequireAuth();
  const promptsData = useTeamsGwPrompts();

  const tenant = auth?.tenant;

  const {
    onSubmit,
    exit,
    setPromptChanges,
    updatePromptsInfo,
    errorMsg,
    showProgress,
    submitEnabled,
    setSubmitEnabled,
    policies,
    setPolicies,
  } = useSettingsHandlers(auth, promptsData);

  const settings = useMemo(
    () => ({
      policies,
      setPolicies,
      promptsData,
      setPromptChanges,
      setSubmitEnabled,
      updatePromptsInfo,
      usePremiumPrompts: tenant?.settings?.customPrompts?.usePremiumPrompts,
    }),
    [
      policies,
      setPolicies,
      promptsData,
      setPromptChanges,
      setSubmitEnabled,
      updatePromptsInfo,
      tenant?.settings?.customPrompts?.usePremiumPrompts,
    ],
  );

  if (!tenant) {
    return <LoadingMessage />;
  }

  return (
    <SettingsContext.Provider value={settings}>
      <ProgressModal show={showProgress} />
      <Formik
        initialValues={{
          defaultDevicePolicy:
            tenant?.settings?.devices?.defaultDevicePolicy !==
            DevicePolicyEnum.untrusted,

          enableMcuDetection: tenant?.settings?.disableMcuDetection !== true,

          useVideoPrioritizedLayout:
            tenant?.settings?.useVideoPrioritizedLayout !== undefined
              ? tenant?.settings?.useVideoPrioritizedLayout
              : true,
        }}
        onSubmit={onSubmit}
      >
        <Container fluid>
          <Row>
            <Col>
              <ControlPanel onExit={exit} submitEnabled={submitEnabled} />
            </Col>
          </Row>
          <Row>
            {errorMsg && (
              <Badge
                variant="danger"
                style={{
                  padding: '5px 10px 5px 10px',
                  margin: 10,
                  textAlign: 'left',
                  fontSize: '1em',
                }}
              >
                {errorMsg}
              </Badge>
            )}
            <br />
            <Col style={{ paddingTop: 10 }}>
              <MenuTabs />
            </Col>
          </Row>
        </Container>
      </Formik>
    </SettingsContext.Provider>
  );
}

export default Settings;
